import Brand from './styles/Brand.js';

/*
 * Services
 *
 * Everything this package needs from the app it is running in. There are two
 * things, and they are both facts about who is running it rather than how it
 * works.
 *
 * WHAT IS NOT HERE MATTERS AS MUCH AS WHAT IS. The customer lookup, the submit
 * and the assistant all point at the same servers wherever this runs, so they
 * are not the host's business and are not configurable. They live in
 * Requests.js and Sockets.js. Making a fixed endpoint injectable does not buy
 * flexibility, it buys four ways for one of the copies to be pointed somewhere
 * wrong, quietly, and only in production.
 */

let config = {
  colors: null,
  dealership: null
};

/*
 * The dealership this instance belongs to, or null.
 *
 * Null on the Support Center: it is the home office, and who a customer's
 * dealership is has to be looked up. On a replicated website it is the dealership whose
 * site this is, known before the customer has typed anything, which is why
 * their escalations do not need a lookup to find a name to go to.
 *
 * Everything on the object is fair game downstream: the name and phone number
 * for the call screen, the id for routing an escalation and for narrowing what
 * the assistant is allowed to discuss.
 */
export const dealership = () => config.dealership;

/*
 * `colors` is the entire design input: { primary, secondary }.
 *
 * Everything is derived from the primary, including the contrast corrections
 * that keep white text legible on whatever a dealership chose. See styles/Brand.js.
 */
export const setColors = colors => {
  config.colors = colors || null;
  Brand.set({
    primary: colors?.primary,
    secondary: colors?.secondary || '#1D1D1F'
  });
};
export const configure = next => {
  if (next && 'dealership' in next) {
    config.dealership = next.dealership || null;
  }
  if (next?.colors) {
    setColors(next.colors);
  }
};
const Services = {
  configure,
  dealership,
  setColors
};
export default Services;